import { lazy } from "react"
import {
  CROPS_PLANTING_LIST_VIEW,
  CROPS_LIST_VIEW,
  CROP_VIEW,
  CROP_PLANTING_VIEW,
  EDIT_CROP_PLANTING_VIEW,
  NEW_CROP_PLANTING_VIEW,
} from "@/features/crops/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllCropsPlantings = lazy(
  () =>
    import("@/features/crops/views/all-crop-plantings/all-crop-plantings.tsx"),
)
const AllCrops = lazy(
  () => import("@/features/crops/views/all-crops/all-crops.tsx"),
)
const CropDetailView = lazy(
  () => import("@/features/crops/views/crop-detail-view/crop-detail-view.tsx"),
)
const CropPlantingView = lazy(
  () =>
    import("@/features/crops/views/crop-planting-view/crop-planting-view.tsx"),
)
const EditCropPlantingView = lazy(
  () =>
    import(
      "@/features/crops/views/edit-crop-planting-view/edit-crop-planting-view.tsx"
    ),
)
const NewCropPlanting = lazy(
  () =>
    import("@/features/crops/views/new-crop-planting/new-crop-planting.tsx"),
)
export const cropsPlantingsRoutes = [
  {
    path: CROPS_PLANTING_LIST_VIEW,
    element: <AllCropsPlantings />,
  },
  {
    path: NEW_CROP_PLANTING_VIEW,
    element: <NewCropPlanting />,
  },
  {
    path: EDIT_CROP_PLANTING_VIEW,
    element: <EditCropPlantingView />,
  },
  {
    path: CROP_PLANTING_VIEW,
    element: <CropPlantingView />,
  },
]

export const cropRoutes = [
  {
    path: CROPS_LIST_VIEW,
    element: <AllCrops />,
  },
  {
    path: CROP_VIEW,
    element: <CropDetailView />,
  },
]

const DESKTOP_CROPS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: cropRoutes,
  },
]

const DESKTOP_CROP_PLANTINGS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: cropsPlantingsRoutes,
  },
]

const MOBILE_CROPS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: cropRoutes,
  },
]

const MOBILE_CROP_PLANTINGS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: cropsPlantingsRoutes,
  },
]

export const getCropRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_CROPS_ROUTES : MOBILE_CROPS_ROUTES
}

export const getCropPlantingRoutes = (isDesktop: boolean) => {
  return isDesktop
    ? DESKTOP_CROP_PLANTINGS_ROUTES
    : MOBILE_CROP_PLANTINGS_ROUTES
}
